import { CREATED_CRM_OBJECT, DELETE_CRM_OBJECTS_SUCCEEDED, FETCH_CRM_OBJECTS_FAILED, FETCH_CRM_OBJECTS_STARTED, FETCH_CRM_OBJECTS_SUCCEEDED } from './crmObjectsActionTypes';
import { createAction } from '@reduxjs/toolkit';
export const createdCrmObjectAction = createAction(CREATED_CRM_OBJECT);
export const getCrmObjectsStartedAction = createAction(FETCH_CRM_OBJECTS_STARTED);
export const getCrmObjectsSucceededAction = createAction(FETCH_CRM_OBJECTS_SUCCEEDED);
export const getCrmObjectsFailedAction = createAction(FETCH_CRM_OBJECTS_FAILED);
export const deleteCrmObjectsSucceededAction = createAction(DELETE_CRM_OBJECTS_SUCCEEDED);